export default __webpack_public_path__ + "static/media/giuriolo-logo.d483478e.png";